import React from 'react'
import clsx from 'clsx'
import { Select, SelectChangeEvent } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import RemoveIcon from '@mui/icons-material/Remove'
import { useIntl } from 'react-intl'
import { GlobalError } from 'react-hook-form'
import TextField from '../../components/formControls/TextField'
import IconButton from '../../components/Button/IconButton'

export type Reminder = {
	id: string
	days: number | null
	sequence: 'before' | 'after'
}

export type AdditionalRemindersListItemProps = {
	data: Reminder
	onChange?: (value: Reminder) => void
	onRemove?: () => void
	errors?: Record<string, GlobalError> & GlobalError
}

const AdditionalRemindersListItem = ({
	data,
	onChange,
	onRemove,
	errors,
}: AdditionalRemindersListItemProps) => {
	const days = data.days ? Math.abs(data.days) : null
	const sequence = data.sequence ?? 'before'

	const { formatMessage } = useIntl()

	const handleDaysChange = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		const newDays = Number(e.target.value)

		if (onChange) {
			onChange({
				...data,
				days: newDays,
			})
		}
	}

	const handleSequenceChange = (e: SelectChangeEvent) => {
		const newSequence = e.target.value as 'before' | 'after'

		if (onChange) {
			onChange({
				...data,
				sequence: newSequence,
			})
		}
	}
	const handleRemove = () => {
		onRemove?.()
	}
	return (
		<div>
			<div
				className={clsx(
					'px-3 py-2 border rounded border-gray-300 !text-sm xl:!text-base'
				)}
			>
				<div className="flex items-center gap-3 xl:gap-5">
					<div className="flex items-end gap-3 xl:gap-5 flex-shrink-0">
						<label htmlFor="days" className="flex items-end gap-2">
							<TextField
								name="days"
								label=""
								type="number"
								className="w-10"
								inputProps={{
									sx: {
										fontSize: 'inherit !important',
									},
									min: 1,
								}}
								controlled={false}
								onChange={handleDaysChange}
								value={days}
								defaultValue={days}
							/>
							{formatMessage({ id: 'auto_task_reminders.days' })}
						</label>
						<label
							htmlFor="sequence"
							className="flex items-end gap-2 flex-shrink-0"
						>
							<Select
								variant="standard"
								name="sequence"
								inputProps={{
									sx: {
										fontSize: 'inherit !important',
									},
								}}
								onChange={handleSequenceChange}
								defaultValue={sequence}
							>
								<MenuItem value="before">
									{formatMessage({
										id: 'auto_task_reminders.before',
									})}
								</MenuItem>
								<MenuItem value="after">
									{formatMessage({ id: 'auto_task_reminders.after' })}
								</MenuItem>
							</Select>
							{formatMessage({ id: 'auto_task_reminders.due_date' })}
						</label>
					</div>
					<div className="ml-auto">
						<IconButton
							key="remove-button"
							tooltipTitle={formatMessage({
								id: 'remove_record.remove',
							})}
							onClick={handleRemove}
							color="error"
						>
							<RemoveIcon />
						</IconButton>
					</div>
				</div>
				{errors && (
					<div className="text-red-500 text-sm mt-2">
						{errors.days?.message}
						{errors.sequence?.message}
						{errors.message}
					</div>
				)}
			</div>
		</div>
	)
}
export default AdditionalRemindersListItem
